import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_MapViewer = _resolveComponent("MapViewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "container" }, [
      _createElementVNode("h1", { class: "text-xl font-bold" }, "Pagina di debug e utility")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_NextButton, {
          component: "a",
          href: "/ricalcola_bi",
          class: "p-1 inline-block"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Ricalcola Bi")
          ])),
          _: 1
        })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("p", null, "Funzione per ricalcolare tutti i record della BI", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_NextButton, {
          component: "a",
          href: "/auth/google/redirect",
          class: "p-1 inline-block"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("Login Google")
          ])),
          _: 1
        })
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, "Funzione con Google", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_NextButton, {
          component: "a",
          href: "/auth/microsoft/redirect",
          class: "p-1 inline-block"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Login Ms")
          ])),
          _: 1
        })
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, "Login con Microsoft", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_NextButton, {
          component: "a",
          href: "/csv_contatti",
          class: "p-1 inline-block"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Sincornizza SB")
          ])),
          _: 1
        })
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, "Sincornizza tutti i contatti su SendinBlue", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_NextButton, {
          onClick: _ctx.test,
          class: "p-1 inline-block"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("test")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_MapViewer, {
      placeId: _ctx.placeId,
      "onUpdate:placeId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.placeId) = $event)),
      lat: _ctx.lat,
      "onUpdate:lat": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lat) = $event)),
      lng: _ctx.lng,
      "onUpdate:lng": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lng) = $event)),
      onAddressInformationChange: _ctx.onAddressInformationChange
    }, null, 8, ["placeId", "lat", "lng", "onAddressInformationChange"])
  ], 64))
}